<template>
  <div>
    <b-container>
      <div class="counters-continer">
        <button @click="showLikes" class="likes-count">
          <span>{{ likes.length }} Likes</span>
        </button>
        <!-- <b-col cols="1"><button><span>0 Shared</span> </button></b-col> -->
      </div>
      <div class="actions-container">
        <div
          ><button
            @click="likeMediaFile"
            :class="isLikedMedia ? 'liked-btn like-btn' : 'like-btn'"
          >
            <i class="fas fa-thumbs-up"></i>
            <span v-if="isLikedMedia">Liked</span> <span v-else>Like</span>
          </button>
        </div>
        <div class="share-btn-container"
          ><button @click="shareImage">
            <i class="fas fa-share"></i>Share
          </button>
        </div>
        <div class="share-btn-container"><button @click="downloadImage" v-if="image">
            <i class="fa fa-download" aria-hidden="true"></i>Download
          </button></div
        >
      </div>
    </b-container>
    <b-modal v-model="openShareModal" hide-footer title="Share Image on Wall">
      <ShareMediaFile :image="image" :video="video" @success="showAlert" />
    </b-modal>
    <b-modal v-model="showLikesModal" title="Likes" hide-footer
      ><b-container>
        <b-row v-for="(data, index) in likes" :key="index">
          <b-col cols="2"
            ><img
              :src="data.customer_details.prof_pic"
              alt=""
              class="profile-pic"
          /></b-col>
          <b-col cols="10">
            <p
              class="user-name"
              @click="
                $router.push({
                  name: 'userProfilePage',
                  params: { customerId: data.customer_details.customer_id },
                })
              "
            >
              {{ data.customer_details.name }}
            </p>
            <p class="user-position">{{ data.customer_details.job_title }}</p>
            <p
              class="user-company"
              @click="
                $router.push({
                  name: 'companyProfile',
                  params: { companyId: data.customer_details.company_id },
                })
              "
            >
              {{ data.customer_details.company }}
            </p>
          </b-col></b-row
        >
      </b-container></b-modal
    >
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import ShareMediaFile from './ShareMediaFile.vue';
import errorHelper from '../../../utils/errorHelper';

export default {
  name: 'GalleryActions',
  components: {
    ShareMediaFile,
  },
  props: {
    image: {
      type: String,
      default: '',
    },
    details: {
      type: Object,
      default: () => null,
    },
    video: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      openShareModal: false,
      likes: [],
      isLikedMedia: false,
      showLikesModal: false,
      likeId: null,
      likeMediaFunctions: {
        event: this.likeEventMedia,
        award: this.likeAwardMedia,
      },
      eventType: '',
    };
  },

  watch: {
    details: {
      deep: true,
      immediate: true,
      handler(details) {
        if (details) {
          if (details.event) {
            this.eventType = 'event';
          } else if (details.award) {
            this.eventType = 'award';
          }

          this.likes = [...details.likes];
          if (this.likes) {
            const data = this.likes.find(
              ({ customer_details }) => this.userInfo.customer_id === customer_details.customer_id,
            );

            this.likeId = data && data.id;

            this.isLikedMedia = !!this.likeId;
          }
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/fetchUserInfo',
    }),
  },
  methods: {
    ...mapActions({
      likeEventMedia: 'mediaArchive/likeEventMedia',
      dislikeEventMedia: 'mediaArchive/dislikeEventMedia',
      likeAwardMedia: 'mediaArchive/likeAwardMedia',
      dislikeAwardMedia: 'mediaArchive/dislikeAwardMedia',
      getBase64Img: 'mediaArchive/getBase64Img',
    }),
    showAlert() {
      this.openShareModal = false;
      this.$notify({
        type: 'success',
        title: 'Success',
        text: 'File shared successfully!',
        group: 'userAlerts',
      });
    },

    async likeMediaFile() {
      try {
        if (this.isLikedMedia) {
          this.dislikeMediaFile();
        } else {
          const data = {
            video: null,
            image: null,
          };

          if (this.image) {
            data.image = `${process.env.VUE_APP_API_HOST}/${this.eventType}s/gallery/${this.details.gallery_id}/`;
          } else if (this.video) {
            data.video = this.video;
          }

          data[this.eventType] = this.details.url;
          const response = await this.likeMediaFunctions[this.eventType](data);
          this.likeId = response.id;
          this.likes.push(response);
          this.isLikedMedia = true;
        }
      } catch (err) {
        errorHelper(err.response).forEach((message) => {
          this.$notify({
            group: 'userAlerts',
            title: 'Error',
            text: message,
            type: 'error',
          });
        });
      }
    },
    async dislikeMediaFile() {
      try {
        if (this.likeId) {
          if (this.details.event) {
            await this.dislikeEventMedia(this.likeId);
          } else if (this.details.award) {
            await this.dislikeAwardMedia(this.likeId);
          }
          this.likes = this.likes.filter(like => like.id !== this.likeId);
          this.isLikedMedia = false;
          this.likeId = null;
        }
      } catch (err) {
        errorHelper(err.response).forEach((message) => {
          this.$notify({
            group: 'userAlerts',
            title: 'Error',
            text: message,
            type: 'error',
          });
        });
      }
    },
    showLikes() {
      if (this.likes.length) {
        this.showLikesModal = true;
      }
    },
    shareImage() {
      this.openShareModal = true;
    },

    async downloadImage() {
      const data = {
        event_gallery: null,
        award_gallery: null,
      };
      data[`${this.eventType}_gallery`] = `${process.env.VUE_APP_API_HOST}/${this.eventType}s/gallery/${this.details.gallery_id}/`;
      const response = await this.getBase64Img(data);

      const a = document.createElement('a');
      a.href = `data:image/png;base64,${response.image_base64}`;
      a.download = 'image.png';
      a.target = '_blank';
      a.click();
    },
  },
};
</script>

<style scoped>
.counters-continer {
  padding-top: 10px;
}
.likes-count {
  display: flex;
  column-gap: 5px;
}
.actions-container {
  display: flex;
  column-gap: 10px;
  margin-top: 10px;
  align-items: center;
  padding-bottom: 10px;
}
.share-btn-container {
  position: relative;
  top: -2px;
}
i {
  margin-right: 3px;
}

.like-btn {
  display: flex;
  column-gap: 5px;
  align-items: center;
}

button {
  border: unset;
  background-color: white;
  cursor: pointer;
  color: #666666;
  font-size: 10px;
  font-family: Arial;
}
button:hover {
  color: #bd9d5f;
}
button span {
  color: #aaaaaa;
}
.liked-btn {
  color: #bd9d5f;
}
.profile-pic {
  height: 40px;
  object-fit: contain;
  width: 100%;
  margin-bottom: 15px;
}
.user-name {
  font-family: Arial;
  font-size: 13px;
  line-height: 1.23;
  text-align: left;
  font-weight: bold;
  color: #333333;
  margin: 0;
  cursor: pointer;
}
.user-position {
  text-transform: capitalize;
  color: #666666;
  font-size: 10px;
  margin: 0;
}
.user-company {
  font-family: Arial;
  font-size: 9px;
  line-height: 1.23;
  text-align: left;
  font-weight: bold;
  color: #bd9d5f;
  margin: 0;
  cursor: pointer;
}
</style>
